import { render, staticRenderFns } from "./recommend-result-chuangxin.vue?vue&type=template&id=237c1b60&scoped=true&"
import script from "./recommend-result-chuangxin.vue?vue&type=script&lang=js&"
export * from "./recommend-result-chuangxin.vue?vue&type=script&lang=js&"
import style0 from "./recommend-result-chuangxin.vue?vue&type=style&index=0&id=237c1b60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237c1b60",
  null
  
)

export default component.exports